import React from 'react';
import { Finish } from '../../data/finishes';

interface FinishSelectorProps {
  finishes: Finish[];
  value: Finish['id'];
  onChange: (id: Finish['id']) => void;
  className?: string;
}

function FinishSelector({ finishes, value, onChange, className = '' }: FinishSelectorProps) {
  const selected = finishes.find((f) => f.id === value);

  return (
    <div className={`flex flex-col items-center gap-4 ${className}`}>
      <div className="relative w-[190px] h-16">
        <div className="absolute inset-0 rounded-full bg-cream shadow-nu-in flex items-center justify-between px-2.5">
          {finishes.map((finish) => (
            <button
              key={finish.id}
              type="button"
              aria-label={`Select ${finish.label} finish`}
              aria-pressed={value === finish.id}
              onClick={() => onChange(finish.id)}
              className={`w-[34px] h-[34px] min-h-[34px] p-0 rounded-full border-2 border-white/60 shadow-[2px_2px_6px_rgba(28,51,80,0.25)] outline-none transition-transform duration-200 hover:scale-[1.08] focus-visible:ring-2 focus-visible:ring-sky focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${finish.swatchClassName} ${
                value === finish.id
                  ? 'scale-[1.1] shadow-[0_0_0_3px_#FFF9EF,0_0_0_5px_#73C7E3]'
                  : ''
              }`}
            />
          ))}
        </div>
      </div>
      <div className="text-[0.85rem] font-semibold text-navy tracking-wide" aria-live="polite">
        {selected?.label}
      </div>
    </div>
  );
}

export default FinishSelector;
